document.addEventListener('DOMContentLoaded', function() {

	/**
	 * Reveal and hide site header on scroll.
	 */
	const siteHeader = document.querySelector('.site-header');
	const scrollHide = 'site-header--scroll-hide';
	const scrollReveal = 'site-header--scroll-reveal';
	const scrollDelta = 5;
	let didScroll = false;
	let lastScroll = 0;

	// Event listener for scroll.
	window.addEventListener('scroll', () => {
		didScroll = true;
	});

	// Set interval to not check for scrolling instantly.
	setInterval(function() {
		if (didScroll) {
			handlePageScroll();
			didScroll = false;
		}
	}, 100);

	// Handle page scroll.
	function handlePageScroll() {
		const currentScroll = window.pageYOffset;

		if (Math.abs(lastScroll - currentScroll) <= scrollDelta) {
			return;
		}

		if ( currentScroll <= scrollDelta ) {
			// Reached top.
			siteHeader.classList.remove(scrollReveal);
		} else if (currentScroll > lastScroll && currentScroll > siteHeader.offsetHeight) {
			// Scrolling down.
			siteHeader.classList.remove(scrollReveal);
			siteHeader.classList.add(scrollHide);
		} else if (currentScroll < lastScroll && siteHeader.classList.contains(scrollHide)) {
			// Scrolling up.
			siteHeader.classList.remove(scrollHide);
			siteHeader.classList.add(scrollReveal);
		}

		lastScroll = currentScroll;
	}

	/**
	 * Mobile nav toggle.
	 */
	const headerNav = document.querySelector('.site-header__container__nav');
	const headerNavToggle = document.querySelector('.site-header__container__nav-toggle button');

	headerNavToggle.addEventListener('click', function(event) {
		headerNav.classList.toggle('site-header__container__nav--visible');
		headerNavToggle.classList.toggle('nav-toggle--open');
		document.body.classList.toggle('disable-page-scroll');
	});

	/**
	 * Autofocus site search form field.
	 */
	const siteSearchForm = document.querySelector('.searchform');

	if (siteSearchForm) {
		const siteSearchFormField = siteSearchForm.querySelector('input[name="s"]');
		if (siteSearchFormField && siteSearchFormField.value == '') {
			siteSearchFormField.focus();
		}
	}
});
